var _linearGradient, _path, _path2, _path3, _path4, _linearGradient2, _path5, _linearGradient3, _path6, _linearGradient4, _path7, _linearGradient5, _path8, _linearGradient6, _path9, _polygon, _polygon2, _polygon3, _polygon4, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GTfajJ~_QeErPfovRURv~a",
    x1: 10.17,
    x2: 20.571,
    y1: 20.674,
    y2: 43.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GTfajJ~_QeErPfovRURv~a)",
    d: "M15.146,18.853L6.08,40.613c-0.343,0.824,0.483,1.651,1.307,1.308l21.759-9.053L15.146,18.853 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf1928",
    d: "M39.2,24C37,24,35,25,29,28c0,0,5.352-1.03,8-1c0.877,0.01,3,0,3,2v3c0,1.105,0.895,2,2,2h0 c1.105,0,2-0.895,2-2v-3.2C44,25.6,41.651,24,39.2,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf1928",
    d: "M21.2,6H18c-1.105,0-2,0.895-2,2v0c0,1.105,0.895,2,2,2h3c2,0,1.99,2.123,2,3c0.03,2.648-1,8-1,8 c3-6,4-8,4-10.2C26,8.349,24.4,6,21.2,6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M26.707,22.707l-1.414-1.414l3.909-3.91C30.094,16.491,31.28,16,32.542,16H33c0.552,0,1-0.449,1-1v-1 c0-1.654,1.346-3,3-3h1c0.552,0,1-0.449,1-1V8c0-1.654,1.346-3,3-3h4v2h-4c-0.552,0-1,0.449-1,1v2c0,1.654-1.346,3-3,3h-1 c-0.552,0-1,0.449-1,1v1c0,1.654-1.346,3-3,3h-0.458c-0.728,0-1.411,0.283-1.926,0.797L26.707,22.707z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GTfajJ~_QeErPfovRURv~b",
    x1: 30.74,
    x2: 54.511,
    y1: 31.74,
    y2: 55.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d160f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c545ed"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GTfajJ~_QeErPfovRURv~b)",
    d: "M36.289,34.209l0.626,1.877l1.877,0.626c0.278,0.093,0.278,0.486,0,0.579l-1.877,0.626 l-0.626,1.877c-0.093,0.278-0.486,0.278-0.579,0l-0.626-1.877l-1.877-0.626c-0.278-0.093-0.278-0.486,0-0.579l1.877-0.626 l0.626-1.877C35.803,33.93,36.197,33.93,36.289,34.209z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GTfajJ~_QeErPfovRURv~c",
    x1: 36.74,
    x2: 60.511,
    y1: 13.74,
    y2: 37.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d160f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c545ed"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GTfajJ~_QeErPfovRURv~c)",
    d: "M42.289,16.209l0.626,1.877l1.877,0.626c0.278,0.093,0.278,0.486,0,0.579l-1.877,0.626 l-0.626,1.877c-0.093,0.278-0.486,0.278-0.579,0l-0.626-1.877l-1.877-0.626c-0.278-0.093-0.278-0.486,0-0.579l1.877-0.626 l0.626-1.877C41.803,15.93,42.197,15.93,42.289,16.209z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GTfajJ~_QeErPfovRURv~d",
    x1: 26.74,
    x2: 50.511,
    y1: 1.74,
    y2: 25.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d160f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c545ed"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GTfajJ~_QeErPfovRURv~d)",
    d: "M32.289,4.209l0.626,1.877l1.877,0.626c0.278,0.093,0.278,0.486,0,0.579l-1.877,0.626 l-0.626,1.877c-0.093,0.278-0.486,0.278-0.579,0l-0.626-1.877l-1.877-0.626c-0.278-0.093-0.278-0.486,0-0.579l1.877-0.626 l0.626-1.877C31.803,3.93,32.197,3.93,32.289,4.209z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GTfajJ~_QeErPfovRURv~e",
    x1: 4.74,
    x2: 28.511,
    y1: 4.74,
    y2: 28.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d160f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c545ed"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GTfajJ~_QeErPfovRURv~e)",
    d: "M10.289,7.209l0.626,1.877l1.877,0.626c0.278,0.093,0.278,0.486,0,0.579l-1.877,0.626 l-0.626,1.877c-0.093,0.278-0.486,0.278-0.579,0l-0.626-1.877l-1.877-0.626c-0.278-0.093-0.278-0.486,0-0.579l1.877-0.626 l0.626-1.877C9.803,6.93,10.197,6.93,10.289,7.209z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GTfajJ~_QeErPfovRURv~f",
    x1: 2.74,
    x2: 26.511,
    y1: 14.74,
    y2: 38.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d160f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c545ed"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GTfajJ~_QeErPfovRURv~f)",
    d: "M8.289,17.209l0.626,1.877l1.877,0.626c0.278,0.093,0.278,0.486,0,0.579l-1.877,0.626 l-0.626,1.877c-0.093,0.278-0.486,0.278-0.579,0l-0.626-1.877l-1.877-0.626c-0.278-0.093-0.278-0.486,0-0.579l1.877-0.626 l0.626-1.877C7.803,16.93,8.197,16.93,8.289,17.209z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#007ad9",
    points: "24.535,34.786 26.381,34.018 23.44,27.155 19.63,23.341"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#007ad9",
    points: "8.046,41.646 9.893,40.878 7.903,36.236 6.831,38.81"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#007ad9",
    points: "11.284,28.123 10.211,30.697 13.866,39.225 15.712,38.457"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#007ad9",
    points: "14.382,20.686 13.31,23.26 19.2,37.006 21.047,36.238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#007ad9",
    d: "M28.439,33.854L14.146,19.561c-0.195-0.195-0.195-0.512,0-0.707l0.707-0.707 c0.195-0.195,0.512-0.195,0.707,0l14.293,14.293c0.195,0.195,0.195,0.512,0,0.707l-0.707,0.707 C28.951,34.049,28.635,34.049,28.439,33.854z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.e6025d3e2feffe69d5f4c5e29a214c34.svg";
export { ForwardRef as ReactComponent };